import React from 'react';
import { motion } from 'motion/react';
import { Twitter, Zap, MessageSquare, Repeat } from 'lucide-react';
import SEO from '../../components/SEO';
import { Link } from 'react-router-dom';

const XTwitter = () => {
  return (
    <div className="pt-24 pb-24 bg-[#030303] min-h-screen">
      <SEO 
        title="AI X / Twitter Post Generator - Write Better Threads"
        description="Generate viral X / Twitter posts, threads, and hooks with PlataPost's AI tweet generator. Boost your engagement and grow your audience."
      />

      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-20 mb-40">
          <div className="flex-1 space-y-8">
            <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full glass-card border border-white/5 text-white text-[10px] font-black uppercase tracking-widest leading-none">
              <Zap className="w-3.5 h-3.5" />
              <span>Real-time Viral</span>
            </div>
            <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight tracking-tighter">AI X / Twitter <br /> <span className="text-white">Post Generator.</span></h1>
            <p className="text-xl text-gray-400 mb-8 leading-relaxed font-medium">
              Master the fast-paced world of X. PlataPost creates punchy short posts and deep-dive threads that get noticed in the feed.
            </p>
            <Link to="/dashboard" className="inline-flex px-10 py-5 bg-indigo-600 text-white rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
              Generate My Next Post
            </Link>
          </div>
          <div className="flex-1 w-full glass-card rounded-[4rem] p-12 flex items-center justify-center border border-white/5 relative overflow-hidden group shadow-2xl shadow-white/5">
             <div className="absolute inset-0 bg-white/5 blur-[100px] pointer-events-none" />
             <div className="w-full max-w-sm bg-white/5 rounded-3xl border border-white/10 p-10 shadow-2xl relative z-10 group-hover:scale-105 transition-transform duration-700">
                <div className="flex items-center gap-4 mb-8">
                   <div className="w-14 h-14 bg-white/10 rounded-2xl flex items-center justify-center text-white shadow-xl shadow-white/10">
                      <Twitter className="w-8 h-8" />
                   </div>
                   <div className="h-3 w-1/4 bg-white/10 rounded-full" />
                </div>
                <div className="space-y-4">
                   <div className="h-3 w-full bg-white/10 rounded-full" />
                   <div className="h-3 w-full bg-white/10 rounded-full" />
                   <div className="h-3 w-3/4 bg-white/20 rounded-full shadow-[0_0_10px_rgba(255,255,255,0.1)]" />
                </div>
             </div>
          </div>
        </div>

        <section className="mb-40">
          <div className="text-center mb-24 space-y-4">
            <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tighter leading-tight">Short, Punchy, Powerful</h2>
            <p className="text-gray-400 font-medium max-w-xl mx-auto">Dominate the timeline with concise yet impactful messaging.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
             {[
               { icon: Zap, title: "Thread Creation", desc: "Turn long-form ideas into high-engagement X threads automatically." },
               { icon: MessageSquare, title: "Punchy Hooks", desc: "Hooks designed to get clicks and expand your reach beyond your followers." },
               { icon: Repeat, title: "Growth Strategy", desc: "Consistent posting schedules optimized for the current X algorithm." }
             ].map((feature, i) => (
                <div key={i} className="p-12 glass-card rounded-[3rem] border border-white/5 hover:bg-white/5 transition-all group">
                   <div className="w-20 h-20 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center mb-10 text-white group-hover:scale-110 group-hover:rotate-6 transition-all shadow-xl shadow-white/5">
                      <feature.icon className="w-10 h-10" />
                   </div>
                   <h3 className="text-3xl font-black text-white mb-6 tracking-tight">{feature.title}</h3>
                   <p className="text-gray-400 leading-relaxed font-medium">{feature.desc}</p>
                </div>
             ))}
          </div>
        </section>

        <div className="text-center glass-card rounded-[4rem] p-24 border border-white/5 relative overflow-hidden shadow-2xl shadow-indigo-600/5">
           <div className="absolute inset-0 bg-indigo-600/10 blur-[150px] pointer-events-none" />
           <h2 className="text-4xl lg:text-6xl font-black text-white mb-10 tracking-tighter">Ready to dominate the <span className="text-indigo-400">timeline?</span></h2>
           <Link to="/booking" className="relative z-10 inline-flex px-12 py-6 bg-indigo-600 text-white rounded-2xl font-black text-sm uppercase tracking-[0.2em] hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
              Get Demo
           </Link>
        </div>
      </div>
    </div>
  );
};

export default XTwitter;
